export const USER_LOGIN_REQUEST='USER_LOGIN_REQUEST'
export const USER_LOGIN_SUCCESS='USER_LOGIN_SUCCESS'
export const USER_LOGIN_FAIL='USER_LOGIN_FAIL'
export const USER_LOGOUT='USER_LOGOUT'

export const USER_REGISTER_REQUEST='USER_REGISTER_REQUEST'
export const USER_REGISTER_SUCCESS='USER_REGISTER_SUCCESS'
export const USER_REGISTER_FAIL='USER_REGISTER_FAIL'

export const USER_DETAILS_REQUEST='USER_DETAILS_REQUEST'
export const USER_DETAILS_SUCCESS='USER_DETAILS_SUCCESS'
export const USER_DETAILS_FAIL='USER_DETAILS_FAIL'
export const USER_DETAILS_RESET='USER_DETAILS_RESET'


export const USER_UPDATE_PROFLE_REQUEST='USER_UPDATE_PROFLE_REQUEST'
export const USER_UPDATE_PROFLE_SUCCESS='USER_UPDATE_PROFLE_SUCCESS'
export const USER_UPDATE_PROFLE_FAIL='USER_UPDATE_PROFLE_FAIL'
export const USER_UPDATE_PROFLE_RESET='USER_UPDATE_PROFLE_RESET'

export const USER_LIST_REQUEST='USER_LIST_REQUEST'
export const USER_LIST_SUCCESS='USER_LIST_SUCCESS'
export const USER_LIST_FAIL='USER_LIST_FAIL'
export const USER_LIST_RESET='USER_LIST_RESET'

export const USER_DELETE_REQUEST='USER_DELETE_REQUEST'
export const USER_DELETE_SUCCESS='USER_DELETE_SUCCESS'
export const USER_DELETE_FAIL='USER_DELETE_FAIL'

export const USER_UPDATE_REQUEST='USER_UPDATE_REQUEST'
export const USER_UPDATE_SUCCESS='USER_UPDATE_SUCCESS'
export const USER_UPDATE_FAIL='USER_UPDATE_FAIL'
export const USER_UPDATE_RESET='USER_UPDATE_RESET'
